import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import LayoutBuilder from '../../../../modules/layout-builder'
import defaultLayout from '../../../../config/layouts/home'
import ScreenHomeSkeleton from './skeleton'
import MessageError from '../../../Error/screens/MessageError'
import translate from '../../../../modules/translate'
import ErrorBoundary from '../../../Error/widgets/ErrorBoundary'
import { setStoredItem, getStoredItem } from '../../../../modules/stored-item'
import hasItems from '../../../../modules/has-items'
import WidgetTopTopic from '../../../Article/widgets/WidgetTopTopic'
import isServerSide from '../../../../modules/is-server-side'

const errorOptions = {
  component: translate('homepage_error'),
  logError: 'Home screen display',
}

const useDataStorage = ({ data, path }) => {
  const [isStorageSet, setStorage] = useState(false)

  const dataHome =
    isStorageSet && getStoredItem(path + '-response') ? JSON.parse(getStoredItem(path + '-response')) : data
  if (data) {
    setStoredItem(path + '-response', JSON.stringify(data))
    data.lastArticleId && setStoredItem('lastArticleId', data.lastArticleId.toString())
  }
  if (!isServerSide()) {
    window.onpopstate = () => {
      setStorage(true)
    }
  }
  return dataHome
}

const HomeScreen = ({ response, loading, error, ready, layout, match, data, ...props }) => {
  if (!data) data = ready && response.data
  const dataHome = useDataStorage({ data: data, path: '/' })

  return (
    <ErrorBoundary {...errorOptions}>
      {error && <MessageError logInfo={error.message} {...errorOptions} />}
      {loading && <ScreenHomeSkeleton layout={layout} {...props} />}
      {ready && hasItems(dataHome.toptopic) && <WidgetTopTopic data={dataHome.toptopic} />}
      {dataHome && <LayoutBuilder layout={layout} data={dataHome} {...props} />}
    </ErrorBoundary>
  )
}

HomeScreen.defaultProps = {
  layout: defaultLayout.feed,
}

HomeScreen.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  layout: PropTypes.object,
}

export default withTheme(HomeScreen)
